import PageLayoutLoading from '@/pages/PageLayoutLoading';
import { useTeamPermissions } from '@/providers/team-permissions-provider';
import { hasRouteTeamPermission } from '@/utils/permissions/has-route-team-permission';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Deny access if user navigates, with the app already loaded, to page where it does not have access
 * @param Component
 */
export function WithTeamPermissionCheck(Component: React.ComponentType) {
    function TeamPermissionHoc() {
        const { teamPermissions } = useTeamPermissions();
        const pathname = useLocation().pathname;
        const hasTeamPermission = hasRouteTeamPermission(pathname, teamPermissions);
        const navigate = useNavigate();

        useEffect(() => {
            if (!hasTeamPermission) {
                navigate('/team-access-denied');
            }
        }, [hasTeamPermission, navigate]);

        if (hasTeamPermission) {
            return <Component />;
        } else {
            return <PageLayoutLoading />;
        }
    }

    return TeamPermissionHoc;
}
